export default "__VITE_ASSET__DL3xXUjv__"